import React from 'react';

import {
  PopoverWrapper,
  PopoverArrow,
  PopoverContent,
  POPOVER_TRANSITION_DURATION,
  PopoverTransition,
} from './style';
import {
  PopoverPlacement,
  PopoverBaseProps,
} from 'components/PopoverBase/types';
import PopoverBase from 'components/PopoverBase';
import { Transition } from 'react-transition-group';
import { viewportFitModifier } from 'utils/popover/viewportFitModifier';

type OwnProps = {
  arrow?: boolean;
  children: React.ReactElement;
  curveBorder?: boolean;
  disabled?: boolean;
  marginToTarget?: number;
  placement?: PopoverPlacement;
  target: React.ReactElement;
  fixTop?: number;
  viewportFit?: boolean;
  overflowVisible?: boolean;
};

type ComponentProps = OwnProps & PopoverBaseProps;

const APopover: React.FC<ComponentProps> = ({
  arrow = false,
  children,
  curveBorder = true,
  marginToTarget = 6,
  placement = 'bottom',
  target,
  fixTop,
  viewportFit = false,
  overflowVisible = false,
  modifier,
  ...props
}: ComponentProps) => {
  const popperModifiers = viewportFit
    ? { ...modifier, ...viewportFitModifier }
    : modifier;

  return (
    <PopoverBase
      placement={placement}
      target={target}
      modifier={popperModifiers}
      {...props}
      childrenRenderFunc={({ placement, ref, style, arrowProps }) => {
        return (
          <PopoverWrapper
            fixTop={fixTop}
            arrow={arrow}
            ref={ref}
            style={style}
            data-placement={placement}
            marginToTarget={arrow ? 14 : marginToTarget}
            viewportFit={viewportFit}
            overflowVisible={overflowVisible}
          >
            {viewportFit ? (
              <>
                {arrow && (
                  <PopoverArrow
                    ref={arrowProps.ref}
                    data-placement={placement}
                    style={arrowProps.style}
                  />
                )}
                <PopoverContent
                  arrow={arrow}
                  curveBorder={curveBorder}
                  data-placement={placement}
                >
                  {children}
                </PopoverContent>
              </>
            ) : (
              <Transition
                in={true}
                timeout={POPOVER_TRANSITION_DURATION}
                appear={true}
              >
                {(state) => (
                  <PopoverTransition transitionState={state}>
                    {arrow && (
                      <PopoverArrow
                        ref={arrowProps.ref}
                        data-placement={placement}
                        style={arrowProps.style}
                      />
                    )}
                    <PopoverContent
                      arrow={arrow}
                      curveBorder={curveBorder}
                      data-placement={placement}
                    >
                      {children}
                    </PopoverContent>
                  </PopoverTransition>
                )}
              </Transition>
            )}
          </PopoverWrapper>
        );
      }}
    />
  );
};

export default APopover;
